import { Module } from '@alipay/mana-syringe';
import { DarkTheme } from './dark';
import { WhiteTheme } from './white';
export default Module((register) => {
    register(DarkTheme);
    register(WhiteTheme);
});
